<template>
  <div class="flex items-center">
    <span class="px-1"> · </span>
    <span class="font-black text-[#F28B82]"><slot></slot></span>
    <svg focusable="false" width="16" height="16" viewBox="0 0 24 24" class="text-[#F28B82] ml-[4px] mb-[1px]"
      aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2z" fill="currentColor"></path>
      <path d="M13 16h-2v2h2v-2zm0-6h-2v4h2v-4z" fill="currentColor"></path>
    </svg>
  </div>
</template>


<script>
export default {}
</script>
